import React, { useState } from "react"
import { Col, Container, Input, Row } from "reactstrap"
import UploadMedia from "../../../../../components/common/UploadMedia/UploadMedia"
import styles from "./styles.module.scss"
import FilterInTable from "../../../../Manage/FilterInTable"
import DataTable from "react-data-table-component"
import { convertCurrency } from "../../../../../utility/Utils"
import { customStyles } from "../DataTableStyles"

const GiftWrapping = () => {
  const [image, setImage] = useState([])

  const data = [
    { name: "Classic Wrap", price: 500 },
    { name: "Festive Wrap", price: 700 },
  ]

  const columns = [
    { name: "Name", selector: (row) => row.name },
    { name: "Price", cell: (row) => <span>${convertCurrency(row.price)}</span> },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center">
          <div style={{ padding: ".3rem .8rem", border: "1px solid black", borderRadius: ".5rem" }} onClick={() => console.log(row.name)}>
            Edit
          </div>
          <div>Delete</div>
        </div>
      ),
    },
  ]

  return (
    <Container fluid>
      <h5 className="fw-medium my-3">Add Gift Wrapping Option</h5>

      <div className="bg-white p-1">
        <div className="m-1 p-3" style={{ border: "2px solid #D9D9D9" }}>
          <Row className="g-0 py-2">
            <Col sm="12" lg="1">Name:</Col>
            <Col sm="12" lg="3">
              <Input type="text" placeholder="Gift wrap name" className={styles["input"]} />
            </Col>
          </Row>
          <Row className="g-0 py-2">
            <Col sm='12' lg="1">Description:</Col>
            <Col sm='12' lg="11">
              <Input type="textarea" className={styles["input"]} />
            </Col>
          </Row>
          <Row className="g-0 py-2">
            <Col sm='12' lg="1">Price:</Col>
            <Col sm='12' lg="2">
              <Input type="number" className={styles["input"]} />
            </Col>
          </Row>
          <Row className="g-0 py-2">
            <Col sm='12' lg="1">Add Image:</Col>
            <Col sm='12' lg="3">
              <UploadMedia pictures={image} setPictures={setImage} allowImages={true} allowVideos={false} maxMedia={1} />
            </Col>
          </Row>
        </div>
      </div>

      <h5 className="fw-medium my-3">Existing Gift Wrapping Options</h5>

      <Row>
        <Col sm='12' lg="8">
          <div className="bg-white p-1 d-grid gap-2">
            <div className="m-1 p-3" style={{ border: "2px solid #D9D9D9" }}>
              <FilterInTable componentName="Existing Gift Wrapping Options" />

              <DataTable columns={columns} data={data} customStyles={customStyles} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default GiftWrapping
